import React  from 'react'
import DropDown from '../dropdown';
import {AccountingSystem} from '../../../api/services/next'

const AccountingSystemTypeDropDown = ({...rest}) => {			
   return <DropDown search  api={AccountingSystem.GetAccountingSystemTypes} textField="Name" valueField="Id"  {...rest}/>
}

export default AccountingSystemTypeDropDown

